"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _googleMapReact = _interopRequireDefault(require("google-map-react"));

function Map(props) {
  var googleMapKey = process.env.GATSBY_GOOGLE_MAP_KEY;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        height: "".concat(props.data.height, "rem"),
        width: "".concat(props.data.width, "rem")
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_googleMapReact["default"], {
      bootstrapURLKeys: {
        key: "".concat(googleMapKey)
      },
      defaultCenter: {
        lat: props.data.defLatitude,
        lng: props.data.defLongitude
      },
      defaultZoom: props.data.defZoom
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      style: {
        position: 'absolute',
        width: 40,
        height: 40,
        left: -40 / 2,
        top: -40 / 2,
        border: '5px solid #f44336',
        borderRadius: 40,
        backgroundColor: 'white',
        textAlign: 'center',
        color: '#3f51b5',
        fontSize: 16,
        fontWeight: 'bold',
        padding: 4
      },
      lat: props.data.latitude,
      lng: props.data.longitude
    }, props.data.label)))
  );
}

var _default = Map;
exports["default"] = _default;